import { ProviderModel, ProviderModelType, ProviderNames } from '../../../../gamma-api';

export const PROVIDER_NAMES = {
  [ProviderNames.Openai]: 'OpenAI',
  [ProviderNames.OpenaiLike]: 'OpenAI compatible',
  [ProviderNames.Yandex]: 'Yandex Cloud',
  [ProviderNames.Gigachat]: 'Giga',
  [ProviderNames.Infinity]: 'Infinity',
  [ProviderNames.Deepinfra]: 'DeepInfra',
  [ProviderNames.Vllm]: 'vLLM',
};

export const MODEL_TYPE_NAMES = {
  [ProviderModelType.Llm]: 'LLM',
  [ProviderModelType.Embedding]: 'Embedding',
  [ProviderModelType.Rerank]: 'Rerank',
};

export const MODEL_PROVIDER_NAMES_OPTIONS = [
  {
    label: PROVIDER_NAMES[ProviderNames.Openai],
    value: ProviderNames.Openai,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.OpenaiLike],
    value: ProviderNames.OpenaiLike,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.Yandex],
    value: ProviderNames.Yandex,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.Gigachat],
    value: ProviderNames.Gigachat,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.Infinity],
    value: ProviderNames.Infinity,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.Deepinfra],
    value: ProviderNames.Deepinfra,
  },
  {
    label: PROVIDER_NAMES[ProviderNames.Vllm],
    value: ProviderNames.Vllm,
  },
];

export const MODEL_TYPES_OPTIONS = [
  {
    label: MODEL_TYPE_NAMES[ProviderModelType.Llm],
    value: ProviderModelType.Llm,
  },
  {
    label: MODEL_TYPE_NAMES[ProviderModelType.Embedding],
    value: ProviderModelType.Embedding,
  },
  {
    label: MODEL_TYPE_NAMES[ProviderModelType.Rerank],
    value: ProviderModelType.Rerank,
  },
];

export const PROVIDER_SETTINGS_DEFAULTS: Record<ProviderNames, Record<string, unknown>> = {
  [ProviderNames.Openai]: { api_base: '' },
  [ProviderNames.OpenaiLike]: { api_base: '' },
  [ProviderNames.Deepinfra]: { api_base: '' },
  [ProviderNames.Vllm]: { api_base: '' },
  [ProviderNames.Infinity]: { api_base: '' },
  [ProviderNames.Yandex]: { folder_id: '' },
  [ProviderNames.Gigachat]: { scope: '' },
};

export const DEFAULT_PROVIDER = {
  title: '',
  name: ProviderNames.Openai,
  enabled: true,
  provider_id: '',
  settings: {
    provider_type: ProviderNames.Openai,
    api_base: '',
    api_key: '',
    models: [],
  },
} as ProviderModel;

export const MAX_MODEL_NAMES_TOTAL_LENGTH = 60;

export const API_KEY_MASKED_LENGTH = 8;
export const API_KEY_VISIBLE_LENGTH = 4;
